import { useResource } from '@landsbankinn/l16n';
import { Col } from '@landsbankinn/ui-kit';
import { Loading } from 'src/components/Loading/Loading';
import { type PkiSimHubData } from 'src/services/ElectronicIdHubService';
import { useElectronicIdSubscriber } from '../../hooks/useElectronicIdSubscriber';
import { MockAuthenticator } from '../MockAuthenticator';
import { res } from './PkiSimCode.res';

export function PkiSimCode() {
  const { r } = useResource();
  const { data } = useElectronicIdSubscriber<PkiSimHubData>('PKISim');
  const description = data?.holdingPageSigningMessage
    ? data.holdingPageSigningMessage
    : data?.code
      ? r(res.loadingPKISIMDescription(data.code))
      : '';
  return (
    <PkiSimLoading
      description={description}
      debugStateId={data?.debugStateId}
    />
  );
}

type PkiSimLoadingWithCodeProps = { code: string; debugStateId?: string };
export function PkiSimLoadingWithCode({
  code,
  debugStateId,
}: PkiSimLoadingWithCodeProps) {
  const { r } = useResource();
  const description = code ? r(res.loadingPKISIMDescription(code)) : '';
  return (
    <Col>
      <PkiSimLoading description={description} debugStateId={debugStateId} />
    </Col>
  );
}

type PkiSimLoadingProps = { description: string; debugStateId?: string };
function PkiSimLoading({ description, debugStateId }: PkiSimLoadingProps) {
  const { r } = useResource();
  const title = r(res.loadingPKISIMTitle);
  return (
    <>
      <Loading title={title} description={description} />
      {debugStateId && (
        <MockAuthenticator debugUrl={'/ElectronicId/Mock?id=' + debugStateId} />
      )}
    </>
  );
}
